
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import { defineComponent, PropType } from 'vue';
export default defineComponent({
  name: 'ListPackage',
  props: {
    pkg: {
      type: Object as PropType<PackageT>,
      required: true
    },
    workspaceId: {
      type: String,
      required: true
    }
  },
  data(): {
    open: boolean;
  } {
    return {
      open: false
    };
  },
  mounted() {
    console.log(this.$props.pkg.launchFiles);
  }
});
